<template>
  <div
    id="ld-content"
    class="ld-download"
  >
    <div class="img-area">
      <img
        class="tool-icon"
        src="./images/tool-icon.svg"
        alt="图标"
      >
      <p class="img-title color-section">
        {{ $t('zBox WebTool插件') }}
      </p>
    </div>
    <p
      v-if="!isMacOs"
      class="color-section marb10"
    >
      {{ $t('请下载并安装zBox WebTool插件进行操作') }}
    </p>
    <p
      v-else
      class="color-section marb10"
    >
      {{ $t('如果已安装zBox WebTool，请直接运行') }}
      <br>
      {{ $t('如果未安装zBox WebTool，请下载并安装') }}
    </p>
    <p class="color-tips">
      {{ $t('安装后，再次点击此按钮，即可在电脑上继续执行操作') }}
    </p>
    <div class="footer">
      <button
        class="default close c-btn"
        @click="cancel"
      >
        {{ $t(isMacOs? '我已安装':'取消') }}
      </button>
      <button
        class="primary down-load s-btn"
        @click="download"
      >
        {{ $t(isMacOs? '下载插件': '下载') }}
      </button>
    </div>
  </div>
</template>
<script>

import { isMacOs, isLinux } from 'js/util/util.js'

export default {
  data() {
    return {
      title: this.$t('安装zBox WebTool插件'),
    }
  },
  computed: {
    isMacOs() {
      return isMacOs()
    },
  },
  methods: {
    download() {
      let url = ''
      if(isLinux()){
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.deb'
      } else if(isMacOs()) {
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.dmg'
      } else{
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.exe'
      }
      window.open(url, '_self')
      this.$emit('after-download')
    },
    cancel() {
      this.$emit('closeParentDialog')
    },
  },
}
</script>
<style lang="less">
@import '~less/ldtool-dialog.less';
</style>
